import { DeepPartial } from "react-hook-form";
import { DeclarativeCompany, legal_entity } from "@/features/company/types";

export const buildDeclarativeDataFormLegalEntity = (
  legalEntity: legal_entity | undefined
): DeepPartial<DeclarativeCompany> => {
  // This should always contain 1 address which is the main one ...
  const foundCompanyAddress = legalEntity?.Address?.find((ad) => ad.isPrincipalAddress);
  const taxAddress = legalEntity?.tax_address;

  return {
    legalEntityUuid: legalEntity?.UUID ?? undefined,
    address: {
      address: foundCompanyAddress?.Address1 ?? undefined,
      city: foundCompanyAddress?.City ?? undefined,
      countryUuid: foundCompanyAddress?.CountryUuid ?? undefined,
      tag: foundCompanyAddress?.Tag ?? "",
      zipCode: foundCompanyAddress?.ZipCode ?? undefined,
      isMain: true
    },
    activityAddress: {
      address: legalEntity?.AddressActivity?.Address1 ?? undefined,
      city: legalEntity?.AddressActivity?.City ?? undefined,
      countryUuid: legalEntity?.AddressActivity?.CountryUuid ?? undefined,
      tag: "",
      zipCode: legalEntity?.AddressActivity?.ZipCode ?? undefined,
      isMain: true
    },
    rcsNumber: legalEntity?.RCSnumber ?? undefined,
    legalName: legalEntity?.LegalName ?? undefined,
    countryIncorporationUuid: legalEntity?.CountryIncorporationUuid?.toString() ?? undefined,
    incorporationDate: legalEntity?.DateOfIncorporation?.date
      ? new Date(legalEntity.DateOfIncorporation.date)
      : undefined,
    legalFormUuid: legalEntity?.LegalFormUuid ?? undefined,
    activityNaceUuid: legalEntity?.ActivityNaceUuid ?? undefined,
    website: legalEntity?.websiteUrl ?? undefined,
    brand: legalEntity?.Brand ?? undefined,
    vatNumber: legalEntity?.VATNumber ?? undefined,
    taxCountryUuid:
      taxAddress !== null &&
      typeof taxAddress === "object" &&
      "countryUuid" in taxAddress &&
      typeof taxAddress.countryUuid === "string"
        ? taxAddress.countryUuid
        : undefined,
    taxNumber: legalEntity?.tax_address?.tin ?? undefined,
    leiNumber: legalEntity?.LeiNumber ?? undefined
  };
};
